var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.errorCodes)?_c('ul',{staticClass:"validation-error",class:{ 'has-error': _vm.errorCodes.length > 0 }},_vm._l((_vm.errorCodes),function(code){return _c('li',{key:code},[_vm._t(code,function(){return [_vm._v(_vm._s(code))]})],2)}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }